
import Dashboard from '@Dashboard/views/dashboard'
import DashboardEdit from '@Dashboard/views/edit'
import Layout from '@/layouts/RouterView'
// import store from '@/store'
import i18n from '@/locales'

export default {
  index: 1,
  meta: {
    label: i18n.t('dashboard.text_77'),
    icon: 'menu-dashboard',
    permission: 'servers_list',
    catalog: 'home',
  },
  menu: {
    path: '/dashboard',
    meta: {
      // hidden: () => {
      //   if (process.env.VUE_APP_PLATFORM === 'operation' && store.getters.isDomainMode) {
      //     return true
      //   }
      //   return false
      // },
      permission: 'servers_list',
    },
    component: Layout,
    children: [
      {
        name: 'Dashboard',
        path: '',
        meta: {
          permission: 'servers_list',
        },
        component: Dashboard,
      },
      {
        name: 'DashboardEdit',
        path: 'edit',
        meta: {
          permission: 'servers_list',
          layout: 'full-screen',
        },
        component: DashboardEdit,
      },
    ],
  },
}
